import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Imprint from './pages/Imprint';
import PrivacyPolicy from './pages/PrivacyPolicy';
import BarValue from './pages/BarValue';

function App() {
  const [lang, setLang] = useState('en');

  const toggleLang = () => {
    setLang(prev => (prev === 'en' ? 'es' : 'en'));
  };

  return (
    <Router>
      <div className="min-h-screen bg-black flex flex-col selection:bg-amber-400 selection:text-black">
        <Header lang={lang} toggleLang={toggleLang} />
        <main className="flex-grow flex flex-col items-center w-full max-w-3xl mx-auto px-4 sm:px-6">
          <Routes>
            <Route path="/" element={<Home lang={lang} />} />
            <Route path="/bar-value" element={<BarValue lang={lang} />} />
            <Route path="/imprint" element={<Imprint lang={lang} />} />
            <Route path="/privacy" element={<PrivacyPolicy lang={lang} />} />
          </Routes>
        </main>
        <Footer lang={lang} />
      </div>
    </Router>
  );
}

export default App;